import styled from 'styled-components';

export const Wrapper = styled.div``;
export const AlertTitle = styled.span<{ $type: string }>`
  color: ${({ $type, theme }) => ($type === 'success' ? theme.palette.success : theme.palette.error)};
  text-align: center;
  font-size: ${({ theme }) => theme.fs.md};
  font-weight: bold;
  margin-top: ${({ theme }) => theme.spacing.x4};
`;
export const Alertdesc = styled.div`
  text-align: center;
  font-size: ${({ theme }) => theme.fs.xs};
  margin-top: ${({ theme }) => theme.spacing.x4};
`;
